module.exports = __webpack_public_path__ + "static/media/vehicleregistrationfront.0630406e.svg";